import { render, staticRenderFns } from "./inoutStockAccount.vue?vue&type=template&id=24cc1ca8&scoped=true&"
import script from "./inoutStockAccount.vue?vue&type=script&lang=js&"
export * from "./inoutStockAccount.vue?vue&type=script&lang=js&"
import style0 from "./inoutStockAccount.vue?vue&type=style&index=0&id=24cc1ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc1ca8",
  null
  
)

export default component.exports